<div class="mat-typography" [formGroup]="aggregationFG">
  <div class="dialog-header">
    Create Aggregation
  </div>
  <div class="horizontal-separator"></div>
  <div class="dialog-container">
    <div class="download-block">
      <span class="block-title">
        <span>Select metadata</span>
      </span>
      <mat-form-field appearance="outline" >
        <mat-select formControlName="field_path" placeholder="Select metadata" panelClass="filter-select">
          @for (meta of metadataKeys; track meta) {
            <mat-option [value]="meta">{{ columnHeader(meta.name) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="download-block">
      <span class="block-title">
        <span>Select Aggregation Type</span>
      </span>
      <mat-form-field appearance="outline" >
        <mat-select formControlName="aggregation_function" placeholder="Select Aggregation Type" panelClass="filter-select">
          @for (type of aggregationOperators; track type) {
            <mat-option [value]="type">{{ aggregationOperatorLabels[type] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="download-block">
      <span class="block-title">
        <span>Name of Aggregation</span>
      </span>
      <mat-form-field appearance="outline" >
        <input matInput formControlName="name" placeholder="Name of Aggregation" required>
      </mat-form-field>
    </div>
    <div class="download-block">
      <div class="half-block">
        <span class="block-title">
          <span>Units</span>
          <span>Optional</span>
        </span>
        <mat-form-field appearance="outline">
          <input matInput formControlName="unit">
        </mat-form-field>
      </div>
      <div class="half-block">
        <span class="block-title">
          <span>Position</span>
        </span>
        <mat-radio-group class="radio-group" formControlName="unit_before">
          <mat-radio-button [value]="true">Before</mat-radio-button>
          <mat-radio-button [value]="false">After</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
</div>
<div class="button-row ">
  <button mat-button mat-dialog-close class="frmg-secondary-button">Cancel</button>
  <button mat-button class="frmg-primary-button"
    [disabled]="!aggregationFG.valid"
    (click)="create()">Create
  </button>
</div>
